import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitFilterGlobalPartners = createSelector(
  [selectFinancialCockpitState],
  ({ filter }) => filter.globalPartners
)
